export default function R_Percentiles() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Percentiles Component</h1>
      <p>This is the R_Percentiles tutorial section.</p>
    </div>
  );
}
